export const environment = {
  production: false,
  local: false,
  supportMail: 'test-papin@yopmail.com',
  healthUrl: 'https://papin2api.rrsolutionstest.it/health',
  logUrl: 'https://papin2api.rrsolutionstest.it/log-error',
  serverUrl: 'https://papin2api.rrsolutionstest.it/',
  domainUrl: 'https://papinwidget2025.rrsolutionstest.it/',
  paymentWidgetUrl: 'https://eu-test.oppwa.com/v1/paymentWidgets.js',
  baseHref: '/'
};
